import * as material from '@nrwl/angular-material';
import { AuthModule } from './modules/auth/auth.module';
import { CookieService } from 'ngx-cookie-service';
import { EffectsModule } from '@ngrx/effects';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { TokenInterceptor } from '@nrwl/rx-service-auth'; // dont touch =)
import { APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { SentryHandlerService } from '@nrwl/rx-service-sentry';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthStateModule } from '@nrwl/rx-state-auth';
import { environment } from '@nrwl/environment';

export const Library: any[] = [material.AngularMaterialModule];

export const Module: any[] = [
  AuthModule,
  RouterModule.forRoot([]),
  EffectsModule.forRoot([]),
  StoreModule.forRoot([]),
  AuthStateModule,
  !environment.production ? StoreDevtoolsModule.instrument() : [],
];

export const Provider: any = [
  CookieService,
  {
    provide: APP_INITIALIZER,
    useFactory: function (sentryHandler: SentryHandlerService) {
      return () => sentryHandler.init();
    },
    multi: true,
    deps: [SentryHandlerService],
  },
  { provide: ErrorHandler, useClass: SentryHandlerService },
  {
    provide: APP_BASE_HREF,
    useFactory: function getBaseHref(platformLocation: PlatformLocation): string {
      return platformLocation.getBaseHrefFromDOM();
    },
    deps: [PlatformLocation],
  },
];
